export default __webpack_public_path__ + "assets/images/2e59e96848bcd82ee1cfb206c48ea488.png";